import { FC } from 'react';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { DragHandle } from '@/shared/components/drag-and-drop';

import { FinancialOverviewSectionDragControl } from '../../types';

interface FinancialOverviewSectionDragHandleProps {
    control: FinancialOverviewSectionDragControl;
}

export const FinancialOverviewSectionDragHandle: FC<FinancialOverviewSectionDragHandleProps> = ({ control }) => {
    const { token } = useAntDesignTheme();

    return (
        <span
            data-financial-overview-drag-control='true'
            style={{
                alignItems: 'center',
                display: 'inline-flex',
                flex: `0 0 ${control.visible ? '1.5rem' : 0}`,
                marginRight: control.visible ? 0 : '-0.625rem',
                opacity: control.visible ? 1 : 0,
                overflow: 'hidden',
                pointerEvents: control.visible ? 'auto' : 'none',
                transition: `flex-basis ${token.motionDurationMid} ${token.motionEaseInOut}, margin-right ${token.motionDurationMid} ${token.motionEaseInOut}, opacity ${token.motionDurationMid} ${token.motionEaseInOut}, width ${token.motionDurationMid} ${token.motionEaseInOut}`,
                width: control.visible ? '1.5rem' : 0,
            }}
        >
            <DragHandle
                dragHandleProps={control.dragHandleProps}
                isDragging={control.isDragging}
                label={control.label}
                style={{ height: '1.5rem', minWidth: '1.5rem', width: '1.5rem' }}
            />
        </span>
    );
};
